<template>
    <div id="help-modal">
        <h2>Hold on! <span style="display: block">Do you need a hand?</span></h2>
        <iframe class="help-modal-player" width="80%" height="315"
                src="https://www.youtube.com/embed/guf_FTQvjYA">
        </iframe>
        <h2>Let us do it for you</h2>
        <p>One of our experts will be in touch can walk you through these results in great detail.</p>
        <div class="input-group mb-3">
            <input type="text" v-model="name" class="form-control text-field-input" v-on:focus="nameInputFocus" v-bind:class="{'text-danger': notValidName, 'invalid-input': notValidName}" id="name" placeholder="Name" aria-label="Name" aria-describedby="basic-addon1">
        </div>
        <div class="input-group mb-3">
            <input type="text" v-model="email" class="form-control text-field-input" v-on:focus="emailInputFocus" v-bind:class="{'text-danger': notValidEmail, 'invalid-input': notValidEmail}" id="Email" placeholder="Email" aria-label="Email" aria-describedby="basic-addon2">
        </div>
        <div class="input-group mb-3">
            <input type="text" v-model="phone" class="form-control text-field-input" v-on:focus="phoneInputFocus" v-bind:class="{'text-danger': notValidPhone, 'invalid-input': notValidPhone}" id="Phone" placeholder="Phone" aria-label="Phone" aria-describedby="basic-addon3">
        </div>
        <p>By continuing you agree to our <span class="policy-link"><a href="https://soundproperty.com.au/legal/" target="_blank">privacy policy</a></span></p>
        <button v-on:click="sendContactData" type="button" class="btn">Call me</button>
    </div>
</template>

<script>
    export default {
        name: "help-modal",
        data () {
            return {
                name: '',
                email: '',
                phone: '',
                notValidName: false,
                notValidEmail: false,
                notValidPhone: false
            }
        },
        methods: {
            sendContactData: function () {
                var validEmail = this.emailValidation();
                var validName = this.nameValidation();
                var validPhone = this.phoneValidation();

                if (validEmail && validName && validPhone) {
                    this.$emit('sendContactInfo');
                }
            },
            emailValidation() {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (re.test(String(this.email).toLowerCase())) {
                    this.notValidEmail = false;
                    return true;
                } else {
                    this.notValidEmail = true;
                    return false;
                }
            },
            nameValidation() {

                if (this.name.length > 0) {
                    this.notValidName = false;
                    return true;
                } else {
                    this.notValidName = true;
                    return false;
                }
            },
            phoneValidation() {

                if (this.phone.length > 0) {
                    this.notValidPhone = false;
                    return true;
                } else {
                    this.notValidPhone = true;
                    return false;
                }
            },
            emailInputFocus() {
                this.notValidEmail = false;
            },
            nameInputFocus() {
                this.notValidName = false;
            },
            phoneInputFocus() {
                this.notValidPhone = false;
            }
        }
    }
</script>

<style scoped>

    #help-modal {
        width: 400px;
        background-color: #fff;
        color: #465978;
        border: 0.5px solid #465978;
        position: absolute;
        top: 10%;
        left: 50%;
        margin-left: -200px;
        z-index: 1;
    }

    h2 {
        width: 80%;
        margin: 0 auto;
        margin-bottom: 30px;
        margin-top: 15px;
        font-weight: bold;
        text-align: center;
    }

    .help-modal-player {
        display: block;
        margin: 0 auto;
    }

    .input-group {
        width: 65%;
        margin: 0 auto;
    }

    .invalid-input {
        background-color: #ffcccc;
    }

    p {
        width: 65%;
        margin: 0 auto;
        font-size: 12px;
        margin-bottom: 15px;
    }

    .policy-link {
        text-decoration: underline;
    }

    .btn {
        width: 30%;
        margin: 0 auto;
        background-color: #465978;
        color: #fff;
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 30px;
        display: block;
    }

</style>


// WEBPACK FOOTER //
// src/Components/HelpModal.vue